import { history} from "umi";
interface Options {
  timePickerType: 'double' | 'single' | 'range'
  supportTimeTypeList: Array<'day' | 'week' | 'month'>
  dataSource?: 1 | 2 | 3
}


const getStorageCacheValue = () => localStorage.getItem('lockCacheValue') ? JSON.parse((localStorage.getItem('lockCacheValue') ?? '')) : null

// 同一个页面使用同一份 options，所以此处缓存供 FilterBase 组件使用
let cacheOptions: any = {}
let lockCacheValue: any = getStorageCacheValue() ?? null

const saveOptions = (options) => {
  cacheOptions = options
}

export const getCacheOptions = () => cacheOptions

const useLockValue = (options?: Options) => {
  saveOptions(options ?? {})
  const { timePickerType = 'range', supportTimeTypeList = ['day'], dataSource = 1 } = options || {}
  const extendsTimeType = ['rangeTime', 'singleTime', 'contrastDay', 'timeType']
  const defaultExtendsKeyList = [
    'zone',
    'region',
    'system',
    'channel',
    'lang',
    'language',
    'networkType',
    'mediaChannel',
    'competitor',
    'source',
    ...extendsTimeType
  ]
  // 设置锁定的筛选器值
  const setLockValue = (filterValue) => {
    lockCacheValue = filterValue?.isLockFilter ? JSON.parse(JSON.stringify({...filterValue, timePickerType, dataSource})) : null
    localStorage.setItem('lockCacheValue', JSON.stringify(lockCacheValue))
  }

  // 设置页面上的默认值，有 lockValue 则取值设置后返回新的 defaultValue，无则返回传入的初始默认值
  const getPageLockDefaultValue = (defaultValue = {}, keys: Array<string> = []) => {
    // const {filterParams = ''} = history?.location?.query;
    const filterState = history?.location?.state || '';
    // 如果后面要求url传参，filterValue = filterParams || filterState代替filterState，url>state>继承>默认
    
    // 筛选器继承逻辑
    if (!(lockCacheValue = getStorageCacheValue())) {
      if(filterState) {
        defaultValue = getUrlFilterParams(filterState, defaultValue)
      }

      return defaultValue
    }
    let newDefaultValue = {...defaultValue}
    Object.keys(defaultValue).forEach(key => {
      if (keys?.includes(key)) {
        // 1. 时间筛选器不一致无法继承
        // 2. 时间类型不支持无法继承
        if (
          extendsTimeType?.includes(key) &&
          (!supportTimeTypeList?.some(item => item?.toLowerCase() === lockCacheValue?.timeType?.toLowerCase()) ||
          lockCacheValue.timePickerType !== timePickerType)
        ) return
        if (key in lockCacheValue) {
          // 数据源不一致不继承
          if (dataSource !== lockCacheValue?.dataSource && !extendsTimeType?.includes(key)) return
          newDefaultValue[key] = lockCacheValue![key]
        }
      }
    })
    // url继承逻辑，url继承优先级高于筛选器继承

    if(filterState) {
      newDefaultValue = getUrlFilterParams(filterState, newDefaultValue)
    }
    // 防止后面空值null和undefined覆盖初始值，造成a页面没有地区，继承后，地区的继承值为null，带到b页面后页面报错
    Object.keys(newDefaultValue).forEach(key => {
      if (!newDefaultValue?.[key]) {
        delete newDefaultValue?.[key]
      }
    })

    return newDefaultValue
  }

  const getUrlFilterParams = (urlParams,filterParams) => {
      let resultFilterParams = JSON.parse(JSON.stringify(filterParams));
      const urlFilterParams = typeof urlParams === 'string' ? JSON.parse(urlParams)?.filterParams : urlParams?.filterParams
      // const {timeType='',rangeTime=[] } = urlFilterParams;
      for (let key in urlFilterParams) {
        resultFilterParams[key] = urlFilterParams[key]
      }
      return resultFilterParams;
  }
  // 深克隆，防止外部修改锁定值，影响其他页面
  return {
    lockCacheValue: JSON.parse(JSON.stringify(lockCacheValue)),
    defaultExtendsKeyList,
    setLockValue,
    getPageLockDefaultValue
  }
}

export default useLockValue